import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from '../config/api';
import { API_URL } from '../config/api';
import Logo from '../components/Logo';

function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // 'idle', 'sending', 'sent'
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setStatus('sending');

    try {
      await axios.post(`${API_URL}/api/auth/forgot-password`, { email });
      setStatus('sent');
    } catch (error) {
      // Always show success to prevent email enumeration
      setStatus('sent');
    }
  };

  return (
    <div className="min-h-screen bg-gradient-civote flex items-center justify-center p-4">
      <div className="bg-white rounded-card shadow-card w-full max-w-md p-8" data-testid="forgot-password-page">
        <div className="flex flex-col items-center mb-6">
          <Logo size="large" />
          <h1 className="text-2xl font-bold text-gray-800 mt-4 font-rubik">Forgot Password</h1>
        </div>

        {status !== 'sent' ? (
          <>
            <p className="text-gray-600 text-sm font-rubik mb-6 text-center">
              Enter your verified email address and we'll send you a link to reset your password.
            </p>

            {error && (
              <div className="bg-red-50 text-red-600 p-3 rounded-card text-sm font-rubik mb-4" data-testid="forgot-error">
                {error}
              </div>
            )}

            <form onSubmit={handleSubmit} className="space-y-4" data-testid="forgot-form">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Email Address</label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full px-4 py-2 border border-gray-300 rounded-card focus:ring-2 focus:ring-primary focus:border-primary font-rubik"
                  placeholder="your@email.com"
                  required
                  data-testid="email-input"
                />
              </div>

              <button
                type="submit"
                disabled={status === 'sending'}
                className="w-full btn-primary py-3 disabled:bg-gray-400"
                data-testid="send-reset-btn"
              >
                {status === 'sending' ? 'Sending...' : 'Send Reset Link'}
              </button>
            </form>
          </>
        ) : (
          <div className="text-center py-4" data-testid="forgot-success">
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
            </div>
            <h2 className="text-xl font-bold text-gray-800 mb-2 font-rubik">Check Your Email</h2>
            <p className="text-gray-600 font-rubik mb-6">
              If this email is registered and verified, you will receive a password reset link shortly.
            </p>
            <p className="text-sm text-gray-500 font-rubik">
              Didn't receive an email? Make sure you've added and verified an email address on your profile.
            </p>
          </div>
        )}

        <div className="mt-6 text-center">
          <Link 
            to="/" 
            className="text-primary hover:text-primary/80 text-sm font-rubik font-medium"
          >
            ← Back to Login
          </Link>
        </div>
      </div>
    </div>
  );
}

export default ForgotPasswordPage;
